import { Button, Grid } from '@material-ui/core/';
import { Skeleton } from '@material-ui/lab';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openAlert } from '~/store/legacy/actions/alertActions';
import useStyles from '~/components/HomePageDownloadApp.style.js';
import HomePageDownloadLinks from '~/components/HomePageDownloadLinks.jsx';
import Callout from '~/components/ui-kit/Callout/Callout';
import { useAppConfig } from '~/hooks/useAppConfig.js';
import { selectUserServiceRegionId } from '~/store/legacy/selector/userSelectors.js';
import { mixpanel } from '~/third_party/Mixpanel.jsx';
import { toSupportedCountryAbbreviation } from '~/utils/format';
import ImageBox from './ImageBox.jsx';
import { post } from '~/api/request.js';
import { getSessionItem, removeSessionItem, setSessionItem } from '~/store/storage.js';

const InternationalPhoneInput = dynamic(() => import('./ChowbusForm/InternationalPhoneInput.jsx'), {
  ssr: false,
  loading: () => <Skeleton variant='rect' height={45} />,
});

const HomePageDownloadApp = () => {
  const { locale } = useSelector((state) => state.app);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [phoneNumber, setPhoneNumber] = useState(null);

  const targetTime = 60;
  const originTimeStamp = parseInt(getSessionItem('leftTime', 0));
  // 经过的时间
  const getOriginPassedTime = () => {
    if (!originTimeStamp) {
      return 0;
    }
    const rang = Math.floor((Date.now() - originTimeStamp) / 1000);
    // bigger than targetTime => time has passed; interval clock doesn't neet to continue
    if (rang > targetTime) {
      removeSessionItem(['leftTime']);
      return 0;
    }
    return targetTime - rang;
  };
  const originLeftTime = getOriginPassedTime();
  const [msgFlag, setMsgFlag] = useState(0);
  const [leftTime, setLeftTime] = useState(originLeftTime);

  const appConfig = useAppConfig();
  const currentServiceRegionId = useSelector(selectUserServiceRegionId);
  const userServiceRegion =
    !appConfig.isLoading && currentServiceRegionId
      ? appConfig.serviceRegions[currentServiceRegionId]
      : null;

  const onPhoneNumberEntered = (e) => {
    const {
      target: { value: number },
    } = e;
    setPhoneNumber(number);
  };

  useEffect(() => {
    if (!originLeftTime && !msgFlag) {
      return;
    }
    // save the time when the interval clock is started
    let val = originLeftTime ? targetTime - originLeftTime : 0;
    if (!getSessionItem('leftTime', 0)) {
      setSessionItem({ leftTime: `${Date.now()}` });
    }
    let interval = setInterval(() => {
      val++;
      setLeftTime(targetTime - val);
      if (val === targetTime) {
        clearInterval(interval);
        removeSessionItem(['leftTime']);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [msgFlag]);

  const sendText = async () => {
    setMsgFlag(msgFlag + 1);
    mixpanel.track({ name: 'click send download link' });
    try {
      const result = await post({
        url: `/api/${locale}/v2/app_download_sms_services
        `,
        options: { CORS_API: true },
        data: {
          phone_number: phoneNumber.number,
        },
      });
      if (result.status === 200) {
        dispatch(
          openAlert({
            variant: 'success',
            message: 'We have sent a download link to your phone',
          })
        );
      }
    } catch (e) {
      dispatch(
        openAlert({
          variant: 'error',
          message: 'Failed to send download link',
        })
      );
    }
  };

  if (appConfig.isAlipay) {
    return null;
  }

  if (appConfig.isLoading) {
    return <Skeleton variant='rect' height={550} width='100%' />;
  }

  return (
    <Grid
      container
      item
      xs={11}
      sm={11}
      justify='center'
      className={classNames(classes.limitedWidth, classes.downloadContainer)}>
      <Grid
        container
        item
        xs={10}
        lg={8}
        md={10}
        alignItems='center'
        justify='flex-start'
        alignContent='flex-start'>
        <Callout
          title='Get the Best Asian Food Delivery App now!'
          text='Discover and order delicious and authentic Asian food! Simple and easy on Chowbus app.'
        />
        <Grid container style={{ marginBottom: 20, }} spacing={1} className={classNames(classes.textButtonContainer)}>
          <Grid item xs={12} md={8} lg={8}>
            <InternationalPhoneInput variant="download"
              onChange={onPhoneNumberEntered}
              country={toSupportedCountryAbbreviation(userServiceRegion?.country || '')}
            />
          </Grid>
          <Grid item xs={12} md={3} lg={3} className={classes.textMe} container justify='center'>
            <Button
              disabled={!phoneNumber || !phoneNumber.isValid() || leftTime > 0}
              variant='contained'
              color='primary'
              onClick={sendText}
              style={{
                borderRadius: 30,
                width: '100%',
                padding: '6px 15px',
                fontSize: '0.76rem',
                fontWeight: '700',
              }}>
              TEXT ME {leftTime > 0 && `(${leftTime}S)`}
            </Button>
          </Grid>
        </Grid>
        <Grid className={classNames(classes.downloadButtonContainer)} container item xs={12} md={11} lg={8} spacing={1} alignItems='center' justify='flex-start' alignContent='flex-start'>
          <HomePageDownloadLinks />
        </Grid>
      </Grid>
      <Grid
        item
        container
        alignItems='center'
        justify='flex-end'
        xs={10}
        sm={4}
        className={classNames(classes.featuredImageContainer)}
        style={{ marginTop: 20, maxHeight: 520 }}>
        <Grid item style={{ width: 210, overflow: 'hidden', position: 'relative' }}>
          <Link href='/download'>
            <a>
              <ImageBox
                style={{ width: '100%' }}
                src='/homepage/landing-home-phone-new.png'
                alt='Picture of two smart phones with the Chowbus app on the screens'
              />
            </a>
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default HomePageDownloadApp;
